import { usePageTitleStore } from '@/store';

export const usePageTitle = () => {
  return {
    getTitle,
    setTitle,
  };
};

const getTitle = () => {
  return usePageTitleStore().pageTitle;
};

const setTitle = title => {
  title = title ? `${title} | ${import.meta.env.VITE_APP_NAME}` : import.meta.env.VITE_APP_NAME;

  usePageTitleStore().$patch({ pageTitle: title });
};
